/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RxCalculatorFormula from './rx-calculator-formula';
import RxCalculatorFormulaDetail from './rx-calculator-formula-detail';
import RxCalculatorFormulaUpdate from './rx-calculator-formula-update';
import RxCalculatorFormulaDeleteDialog from './rx-calculator-formula-delete-dialog';

const RxCalculatorFormulaRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RxCalculatorFormula />} />
    <Route path="new" element={<RxCalculatorFormulaUpdate />} />
    <Route path=":id">
      <Route index element={<RxCalculatorFormulaDetail />} />
      <Route path="edit" element={<RxCalculatorFormulaUpdate />} />
      <Route path="delete" element={<RxCalculatorFormulaDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RxCalculatorFormulaRoutes;
